export default "__VITE_ASSET__0CvFF53A__"